export default function filter(data=[], filterFunctions=[]) {
  return filterFunctions.reduce((d, f) => d.filter(f), data);
}
